import clsx from "clsx";
import React, { FunctionComponent } from "react";

import { partTypeTire } from "../../../constants/partTypes";
import { useNormalizedPartData } from "../../../i18n/useNormalizedPartData";
import { AnyPartItem } from "../../../stores/slices/cartSlice";
import { Image as Img } from "../../../ui/Image/Image";
import { Placeholder } from "../../../ui/Placeholder";
import { Section } from "../../../ui/Section/Section";
import { getPartFallbackSrc } from "../../../util/getPartFallbackSrc";

type DealerTireDetailsProps = {
  part: AnyPartItem | null;
};

export const Image: FunctionComponent<DealerTireDetailsProps> = ({ part }) => {
  const { fallbackSrc, name, shouldFlip, src } =
    useNormalizedPartData(part) || {};
  return (
    <Section className="flex flex-col items-center">
      <h2 className="text-xl lg:text-2xl text-center mb-2">
        <Placeholder className="w-[8em]">{name}</Placeholder>
      </h2>
      <Img
        className={clsx(
          "object-contain block text-black bg-black rounded sm:rounded-section",
          "w-full sm:w-auto sm:h-[10rem] md:h-[16rem]",
          shouldFlip && "scale-x-[-1]"
        )}
        alt="product image"
        errorClassName="opacity-60 blur-[16px]"
        fallbackSrc={fallbackSrc || getPartFallbackSrc(partTypeTire)}
        src={src}
      />
      {part?.partDetails.primaryPart.itemType === partTypeTire && (
        <img
          alt="Manufacturer logo"
          className="max-h-6 my-2"
          src={part.partDetails.primaryPart.tireManufacturerImage}
        />
      )}
    </Section>
  );
};
